import { apiClient } from './client'
import { getStoredRole } from '../../utils/token'
import {
  ReportQueryParams,
  ReportResponse,
  EventTypeLookup,
} from '../../types/reports'

function buildReportQueryString(params: ReportQueryParams): string {
  const q = new URLSearchParams()

  q.append('advertiser_id', params.advertiser_id.toString())

  if (params.campaign_id?.length) {
    q.append('campaign_id', params.campaign_id.join(','))
  }
  if (params.ad_unit_id?.length) {
    q.append('ad_unit_id', params.ad_unit_id.join(','))
  }
  if (params.ad_id?.length) {
    q.append('ad_id', params.ad_id.join(','))
  }
  if (params.date) q.append('date', params.date)
  if (params.country) q.append('country', params.country)
  if (params.domain !== undefined) q.append('domain', params.domain.toString())
  if (params.date_from) q.append('date_from', params.date_from)
  if (params.date_to) q.append('date_to', params.date_to)
  if (params.timezone) q.append('timezone', params.timezone)

  if (params.breakdowns.length) {
    q.append('breakdown', params.breakdowns.join(','))
  }

  if (params.metrics?.length) {
    q.append('metrics', params.metrics.join(','))
  }

  return `?${q.toString()}`
}

export const reportApi = {
  getReport: async (params: ReportQueryParams): Promise<ReportResponse> => {
    const qs = buildReportQueryString(params)
    const base = getStoredRole() === 'admin' ? '/administrator/reports' : '/reports'
    return apiClient.get<ReportResponse>(`${base}${qs}`, { skipRoleRouting: true })
  },

  getEventTypeLookups: async (): Promise<EventTypeLookup[]> => {
    const response = await apiClient.get<EventTypeLookup[]>('/event_type_lookups', {
      skipRoleRouting: true,
    })
    return Array.isArray(response) ? response : []
  },

  searchEventTypes: async (q: string, perPage = 50): Promise<EventTypeLookup[]> => {
    const params = new URLSearchParams({ per_page: String(perPage) })
    if (q.trim()) params.set('q', q.trim())
    const response = await apiClient.get<EventTypeLookup[]>(
      `/event_type_lookups?${params.toString()}`,
      { skipRoleRouting: true }
    )
    return Array.isArray(response) ? response : []
  },
}
